// extracted by css-extract-rspack-plugin
export default {"label":"adsSetting_label__Pr1N2"};